"use client";

import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

interface ClearReportButtonProps {
  className?: string;
  onCleared?: () => void;
}

export function ClearReportButton({
  className = "",
  onCleared,
}: ClearReportButtonProps) {
  const handleClear = () => {
    try {
      onCleared?.();
      const current = new URL(window.location.href);
      current.searchParams.delete("report");
      window.location.replace(`${current.pathname}${current.search}`);
    } catch {}
  };

  return (
    <Button
      type="button"
      aria-label="Remove report from view"
      variant="secondary"
      onClick={handleClear}
      className={cn(className)}
    >
      <X className="h-4 w-4 mr-2" aria-hidden="true" />
      Clear view
    </Button>
  );
}
